import React, { useContext, useState } from 'react'
import { Form, Button, Input, message, Modal, Select, Tooltip } from 'antd';
import {useFetch} from './../../../utils/hooks/useFetch'
import { appContext } from "./../../../AppContext";
import { IsStormvloed } from '@utils';
const { Option } = Select;

export default function AddCharacterModal({
    isModalVisible, 
    setIsModalVisible, 
    refresh,
    characterTypes,
    races,
}){
    const layout = useFormLayout();
    const [doFetch, FetchOptions] = useFetch();
    const [appState] = useContext(appContext);
    const isStormvloed = IsStormvloed(appState.storyName)

    const [isAdding, setIsAdding] = useState(false)

    const [form] = Form.useForm()

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    const characterTypeOptions = characterTypes?.map(_ => {
        return (<Option 
          value={_.id} 
          key={_.id}
        >
          {_.name}
        </Option>)
      })

    const raceOptions = races?.map(_ => {
    return (<Option 
        value={_.id} 
        key={_.id}
    >
        {_.name}
    </Option>)
    })

    return (
            <Modal 
                title="Add Character" 
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
                
            >
                <Form 
                    form={form}
                    {...layout}
                    name="basic"
                    layout="horizontal"
                    onFinish={onAdd}>

                    <Form.Item
                        label="Name"
                        name="name"
                        // rules={[{required:true, message:"Name is needed"}]}
                    >
                        <Input name="name" />
                    </Form.Item>

                    <Form.Item
                        label="Short description"
                        name="shortDescription"
                        // rules={[{required:true, message:"Name is needed"}]}
                    >
                        <Input name="shortDescription" />
                    </Form.Item>

                    <Form.Item
                        label="Type"
                        name="characterType"
                        rules={[{required:true, message:"Type is needed, but can be changed later"}]}
                        tooltip={
                                <Tooltip>
                                    <span>Please make sure you only have 1 main character. The type can be changed later</span>
                                </Tooltip>
                            }
                    >
                        <Select 
                            allowClear
                            name="characterType" 
                        >
                            {characterTypeOptions}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={isStormvloed ? "Race" : "World"}
                        name="race"
                        rules={[{required:true, message:isStormvloed ? "Race is needed, but can be changed later" : "World is needed, but can be changed later"}]}
                        tooltip={
                                <Tooltip>
                                    { isStormvloed ? <span>The race can be changed later</span> : <span>The world can be changed later</span>}
                                </Tooltip>
                            }
                    >
                        <Select 
                            allowClear
                            name="race" 
                        >
                            {raceOptions}
                        </Select>
                    </Form.Item>

                    <Form.Item >
                        <Button type="primary" htmlType="submit" loading={isAdding}>
                        Add Character
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>
    )

    function onAdd(values)
    {
        setIsAdding(true)
        const url = `/api/character/AddOrUpdateCharacter`;
        const body = {
            story: {
                id:appState.storyId
            },
            name:values.name,
            shortDescription:values.shortDescription,
            characterType: {
                id:values.characterType
            },
            race: {
                id:values.race
            }
        }
        
        doFetch(url, FetchOptions.POST, body)
            .then((response) => onAddInventoryLoaded(response.isSuccess))

        function onAddInventoryLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                form.resetFields();
                setIsModalVisible(false);
                setIsAdding(false);
                return;
            } 

            setIsAdding(false);
            message.error('Could not add Character');
        }
    }

    function useFormLayout()
    {
        return {
            hideRequiredMark: true,
            colon: false,
            layout:"inline"
        }
    }
}